/* ======================================================================== */
/* 28. sliderFullscreen */
/* ======================================================================== */
var SliderFullscreen1 = function ($scope) {

	if (!$scope.find('.js-slider-fullscreen').length) {
		return;
	}

	createSlider();

	function createSlider() {

		var $sliderImg = $('.js-slider-fullscreen__slider-img');

		if (!$sliderImg.length) {
			return;
		}

		/**
		 * Images Slider
		 */
		var
			overlapFactor = $sliderImg.data('overlap-factor') || 0,
			sliderImg = new Swiper($sliderImg[0], {
				autoplay: {
					enabled: $sliderImg.data('autoplay-enabled') || false,
					delay: $sliderImg.data('autoplay-delay') || 6000,
					disableOnInteraction: true
				},
				allowTouchMove: false,
				direction: 'vertical',
				speed: $sliderImg.data('speed') || 800,
				pagination: {
					el: '.js-slider-fullscreen__dots',
					type: 'bullets',
					bulletElement: 'div',
					clickable: true,
					bulletClass: 'slider__dot',
					bulletActiveClass: 'slider__dot_active'
				},
				navigation: {
					prevEl: '.js-slider-fullscreen-arrow-left',
					nextEl: '.js-slider-fullscreen-arrow-right',
				},
				mousewheel: {
					eventsTarged: '.section-fullscreen',
					sensitivity: 1
				},
				keyboard: {
					enabled: true
				},
				watchSlidesProgress: true,
				on: {
					progress: function () {
						var swiper = this;
						for (var i = 0; i < swiper.slides.length; i++) {

							var slideProgress = swiper.slides[i].progress,
								innerOffset = swiper.width * overlapFactor,
								innerTranslate = slideProgress * innerOffset;

							try {
								TweenMax.set(swiper.slides[i].querySelector('img'), {
									y: innerTranslate + 'px',
									transition: swiper.params.speed + 'ms'
								});
							} catch (error) {

							}

						}
					},
					touchStart: function () {
						var swiper = this;
						for (var i = 0; i < swiper.slides.length; i++) {
							try {
								TweenMax.set(swiper.slides[i].querySelector('img'), {
									transition: ''
								});
							} catch (error) {

							}

						}
					},
				}
			});

		var
			tl = new TimelineMax(),
			breakpoints = {},
			fadeEffect = {},
			lg = elementorFrontend.config.breakpoints.lg - 1 || 1024;


		if (!$('.section-fullscreen_1').data('os-animation')) {
			fadeEffect.crossFade = true
		}

		/**
		 * Content Slider
		 */
		var sliderContent = new Swiper('.js-slider-fullscreen__slider-content', {
			speed: $sliderImg.data('speed') || 800,
			effect: 'fade',
			fadeEffect: fadeEffect,
			allowTouchMove: false,
			breakpoints: breakpoints,
		});

		sliderContent.on('slideChange', function () {

			var
				slider = this,
				$activeSlide = $(slider.slides[slider.activeIndex]),
				$slides = $(slider.slides),
				$heading = $slides.find('.slider-fullscreen__slide-header h2 .split-word'),
				$description = $slides.find('.slider-fullscreen__slide-header p .split-word'),
				$categories = $slides.find('.slider__wrapper-categories .split-word'),
				$button = $slides.find('.slider-fullscreen__slide-wrapper-button'),
				$activeHeading = $activeSlide.find($heading),
				$activeDescription = $activeSlide.find($description),
				$activeButton = $activeSlide.find($button),
				duration = NaN;

			if ($sliderImg.data('speed')) {
				duration = parseFloat($sliderImg.data('speed') / 1000);
			}

			tl.clear();

			$heading.each(function () {
				tl.add(hideLines($(this), 0.4), 'start');
			});

			$description.each(function () {
				tl.add(hideLines($(this), 0.4), 'start');
			});

			$categories.each(function () {
				tl.add(hideLines($(this), 0.4), 'start');
			});

			$button.each(function () {
				tl.to($(this), 0.4, {
					autoAlpha: 0,
					y: '10px'
				}, 'start');
			});

			tl
				.add(animateLines($activeHeading, 0.4))
				.add([
					animateLines($activeDescription, 0.4),
					animateLines($categories, 0.4)
				], '-=0.2')
				.to($activeButton, 0.4, {
					autoAlpha: 1,
					y: '0px'
				}, '-=0.2');

			tl.totalDuration(duration);


		});

		renderSliderCounter(
			sliderImg,
			'.js-slider-fullscreen__counter-current',
			'',
			'.js-slider-fullscreen__counter-total',
			sliderContent
		);

	}

}
